export default __webpack_public_path__ + "static/media/my_location_marker.7ee5da38.svg";